import React from 'react';
import { Col, Row, Switch, Tag } from 'antd';

interface FeMasterActivationBannerProps {
  isEnabled: boolean;
  isSharedPool: boolean;
  togglingFe: boolean;
  onToggleEnableFE: (checked: boolean) => void;
}

export const FeMasterActivationBanner: React.FC<FeMasterActivationBannerProps> = ({
  isEnabled,
  isSharedPool,
  togglingFe,
  onToggleEnableFE
}) => {
  return (
    <div style={{
      backgroundColor: isEnabled ? '#f6ffed' : '#fafafa',
      border: `1px solid ${isEnabled ? '#b7eb8f' : '#d9d9d9'}`,
      borderRadius: 8,
      padding: '16px 20px',
      marginBottom: 16
    }}>
      <Row justify="space-between" align="middle">
        <Col xs={24} sm={18}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <strong>Habilitar Facturación Electrónica DIAN</strong>
            <Tag color={isEnabled ? 'success' : 'default'}>
              {isEnabled ? 'HABILITADA' : 'DESHABILITADA'}
            </Tag>
            <Tag color={isSharedPool ? 'purple' : 'blue'}>
              {isSharedPool ? 'Bolsa Compartida' : 'Bolsa Propia'}
            </Tag>
          </div>
          <div style={{ color: '#8c8c8c', fontSize: 13, marginTop: 4 }}>
            Al estar habilitada, las ventas aprobadas en los puntos de venta de esta empresa generarán y validarán automáticamente Facturas Electrónicas ante la DIAN mediante Factus API V2.
          </div>
        </Col>
        <Col xs={24} sm={6} style={{ textAlign: 'right', marginTop: 8 }}>
          <Switch
            checked={isEnabled}
            loading={togglingFe}
            onChange={onToggleEnableFE}
            checkedChildren="Activada"
            unCheckedChildren="Desactivada"
            style={{ transform: 'scale(1.1)' }}
          />
        </Col>
      </Row>
    </div>
  );
};
